import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/coaching.png'
import _imports_1 from '../assets/images/lecture.png'
import _imports_2 from '../assets/images/community.png'


const _withScopeId = n => (_pushScopeId("data-v-4eb4c30c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"title-container text-centered\" data-v-4eb4c30c><h1 class=\"title\" data-v-4eb4c30c> Welcome to <span class=\"highlighted-text\" data-v-4eb4c30c>DB</span>hubs Rocket League </h1><p class=\"sub-title\" data-v-4eb4c30c>Mentality, Coaching, and Community</p><p class=\"text-regular\" data-v-4eb4c30c> With a unique approach to improvement, we care about your growth in life and in Rocket League! </p></section>", 1)
const _hoisted_3 = { class: "tiles-wrapper text-centered" }
const _hoisted_4 = { class: "tiles-container" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Coaches"
  })
], -1))
const _hoisted_7 = { class: "card-description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-title" }, "Top Tier Coaching Team", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-info" }, [
  /*#__PURE__*/_createTextVNode(" Master your skills with "),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "card-list card-points card-bullet-point" }, [
  /*#__PURE__*/_createElementVNode("li", null, " Ex-pros "),
  /*#__PURE__*/_createElementVNode("li", null, " E-sports coaches "),
  /*#__PURE__*/_createElementVNode("li", null, " Top 100 players "),
  /*#__PURE__*/_createElementVNode("li", { class: "hidden" })
], -1))
const _hoisted_11 = {
  href: "#",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_12 = { class: "card" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Live Events"
  })
], -1))
const _hoisted_14 = { class: "card-description" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-title" }, "10+ Live Events per Month", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-info" }, " Spend time with the Coaches and Community! ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "card-list card-points card-bullet-point" }, [
  /*#__PURE__*/_createElementVNode("li", null, " Live coaching "),
  /*#__PURE__*/_createElementVNode("li", null, " Q&A sessions "),
  /*#__PURE__*/_createElementVNode("li", null, " Mentality drop-ins "),
  /*#__PURE__*/_createElementVNode("li", null, " Tournaments ")
], -1))
const _hoisted_18 = {
  href: "#",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Community"
  })
], -1))
const _hoisted_21 = { class: "card-description" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-title" }, "First Week Free", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-info" }, " Sign up now to enjoy ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "card-list card-points card-bullet-point" }, [
  /*#__PURE__*/_createElementVNode("li", null, " Ranking up "),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" A dedicated "),
    /*#__PURE__*/_createElementVNode("span", { class: "hoverhighlight" }),
    /*#__PURE__*/_createTextVNode("community ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Full access for "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--dbhubs-green)"} }, "ONLY $24.99"),
    /*#__PURE__*/_createTextVNode(" a month ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "hidden" })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "join-section" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "tile",
          to: "/coaches"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_router_link, {
                  class: "card-button",
                  to: "/coaches"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("SEE COACHES")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "tile",
          to: "/about"
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _createVNode(_component_router_link, {
                    class: "card-button",
                    to: "/about"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("MORE INFO")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "tile",
          to: "/join"
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _createVNode(_component_router_link, {
                    class: "card-button card-join-button",
                    to: "/join"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("JOIN NOW")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_25
  ]))
}